import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Order', icon: 'ri-shopping-cart-line' },
    { path: '/live-orders', label: 'Live Orders', icon: 'ri-time-line' },
    { path: '/reports', label: 'Reports', icon: 'ri-file-list-line' },
    { path: '/menu', label: 'Menu', icon: 'ri-restaurant-line' }
  ];

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/assets/images/logo.png" 
              alt="Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-semibold text-gray-900">Vendor POS</span>
          </Link>

          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-teal-500 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>

          <div className="md:hidden">
            <button className="text-gray-700 hover:text-gray-900 cursor-pointer">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </div>

      <div className="md:hidden border-t border-gray-200">
        <div className="grid grid-cols-4 gap-1 p-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center py-3 rounded-lg text-xs font-medium transition-colors cursor-pointer ${
                location.pathname === item.path
                  ? 'bg-teal-500 text-white'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <i className={`${item.icon} text-xl w-6 h-6 flex items-center justify-center mb-1`}></i>
              <span className="whitespace-nowrap">{item.label}</span>
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
